<template lang="pug">
.container(id="MediumTagsEditor-container")
  el-form.select-deviceTagsPlayDependency(v-if='medium && currentUserNetwork.playTagDependancyUsed')
    el-form-item(:label='$t("Require matching device tags to play:")', size='mini')
      el-select(id="MediumTagsEditor-deviceTagsPlayDependency" v-model='medium.deviceTagsPlayDependency', @change="deviceTagsPlayDependencyChangeHandler")
        el-option(
          v-for="deviceTagsPlayDependencyOption of deviceTagsPlayDependencyOptions",
          :key="deviceTagsPlayDependencyOption",
          :label="$t(deviceTagsPlayDependencyOption)",
          :value="deviceTagsPlayDependencyOption",
          v-bind:id="'deviceTagsPlayDependencyOption' + deviceTagsPlayDependencyOption"
        )
      span.saving-tag(:class="{ visible: savingNetworkTag }") &nbsp;
        font-awesome-icon.fa-spin(icon="sync")
  .items-container
    .mediumTags.tags-used
      el-tag.tag(v-for='mediumTag in mediumTags', :id="'MediumTagsEditor-tag' + mediumTag.name", :key='mediumTag.id', closable, @close="handleDeleteTagFromMedium(mediumTag)")
        span.cursor-pointer(@dblclick='editNetworkTag(mediumTag)') {{ mediumTag.name }}{{ savingNetworkTag ? '...' : '  '}}
      p.no-tags-warning(id="MediumTagsEditor-noTagsWarning" v-if='mediumTags.length === 0') {{ $t('This medium has no tags.')}}
        span(v-if='unusedNetworktagsInMedium.length > 0') {{ $t(' Click a tag below to assign it to medium') }}
    .mediumTags
      p.no-tags-warning(id="MediumTagsEditor-noNetworkTagsWarning" v-if='unusedNetworktagsInNetwork.length === 0 && unusedNetworktagsInMedium.length === 0 && mediumTags.length === 0')
        span {{ $t('No network tags.') }}
      el-button.tag.tag-unused(v-for='unusedMediumTag in unusedNetworktagsInMedium', :id="'MediumTagsEditor-addUnusedMediumTag' + unusedMediumTag.id",  :key='unusedMediumTag.id', @click='addTagToMedium(unusedMediumTag)', size="small")
        | + {{ unusedMediumTag.name }}
      el-button.tag.tag-unused(v-for='unusedMediumTag in unusedNetworktagsInNetwork', :id="'MediumTagsEditor-addUnusedNetworkTag' + unusedMediumTag.id", :key='unusedMediumTag.id', @click='addTagToMedium(unusedMediumTag)', size="small")
        | + {{ unusedMediumTag.name }}
      el-button(v-if='!inputVisible', size='small', @click='showInput', type='success', plain) {{$t('+ Create Tag')}}
      el-input.input-new-tag(v-if='inputVisible', v-model='addTagName', ref='saveTagInput', size='mini', @keyup.enter.native='addTag', @blur='addTag')
    .errors(v-if="errors.length > 0")
      p.error(v-for="error in errors") {{ error }}
  el-dialog(:close-on-click-modal="false", :visible.sync='editTagFormVisible', append-to-body, @close='editTagFormVisible = false; editedTag = undefined')
    .container(v-if='editedTag' id="MediumTagsEditor-editTagContainer")
      h4 {{$t('Change Tag in Network')}} - {{editedTag.name}}
      el-form(:model='editedTag', @keyup.enter.native='')
        el-form-item
          el-input(id="MediumTagsEditor-editTagNameInput" :placeholder='$t("name")', v-model='editedTag.name', label='Name')
      el-button-group.float-right
        el-button(
          id="MediumTagsEditor-editTagSaveButton", type='success', size="mini", @click='saveNetworkTag()',
          :disabled='savingNetworkTag'
        )
          font-awesome-icon(icon="save")
          span &nbsp; {{ savingNetworkTag ? $t('saving...') : $t('Change tag text')}}
        el-button(
          id="MediumTagsEditor-editTagDeleteButton", type='success', size="mini", @click='deleteNetworkTag()'
          :disabled='deletingNetworkTag'
        )
          font-awesome-icon(icon="trash")
          span &nbsp; {{ deletingNetworkTag ? $t('deleting...') : $t('Delete tag from network')}}
      br
      br
</template>

<script>
import Vue from 'vue'
import userUtils from '../Common/userUtils.mixin'

export default {
  props: ['mediumId'],
  mixins: [userUtils],

  async created () {
    this.medium = JSON.parse(JSON.stringify(this.$store.state.Medium.media_list.find(medium => {
      return medium.id === this.mediumId
    })))
  },
  data () {
    return {
      errors: [],
      inputVisible: false,
      addTagName: '',
      medium: undefined,
      editTagFormVisible: false,
      editedTag: undefined,
      savingNetworkTag: false,
      deletingNetworkTag: false,
      deviceTagsPlayDependencyOptions: ['none', 'all', 'any']
    }
  },
  methods: {
    // FIXME DRY
    async deviceTagsPlayDependencyChangeHandler () {
      this.savingNetworkTag = true
      await Vue.axios.patch('medium/' + this.medium.id, {
        id: this.medium.id,
        deviceTagsPlayDependency: this.medium.deviceTagsPlayDependency
      })
      this.savingNetworkTag = false
    },
    editNetworkTag (tag) {
      this.editedTag = JSON.parse(JSON.stringify(tag))
      this.editTagFormVisible = true
    },
    async saveNetworkTag () {
      this.savingNetworkTag = true
      await this.$store.dispatch('Medium/saveMediumTagInNetwork', this.editedTag)
      this.editTagFormVisible = false
      this.editedTag = undefined
      await this.loadMedium()
      this.savingNetworkTag = false
    },
    async deleteNetworkTag () {
      this.deletingNetworkTag = true
      await this.$store.dispatch('Medium/deleteMediumTagFromNetwork', this.editedTag.id)
      this.editTagFormVisible = false
      this.editedTag = undefined
      await this.loadMedium()
      this.deletingNetworkTag = false
    },
    async handleDeleteTagFromMedium (tag) {
      this.savingNetworkTag = true
      await this.$store.dispatch('Medium/deleteMediumTagFromMedium', [tag.id, this.medium.id])
      this.savingNetworkTag = false
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    async addTag () {
      if (!this.addTagName || this.addTagName.length === 0) return
      // check if tag already exists in unused tags
      this.errors = []
      if (
        this.unusedNetworktagsInMedium.find(mt => mt.name === this.addTagName) ||
        this.unusedNetworktagsInNetwork.find(mt => mt.name === this.addTagName) ||
        this.mediumTags.find(mt => mt.name === this.addTagName)
      ) {
        return this.errors.push(`Tag ${this.addTagName} already exists`)
      }
      const createdTag = await this.$store.dispatch('Medium/addMediumTag', this.addTagName)
      await this.addTagToMedium(createdTag)
      this.inputVisible = false
      this.addTagName = ''
    },
    async addTagToMedium (tag) {
      this.savingNetworkTag = true
      await this.$store.dispatch('Medium/addMediumTagToMedium', [tag.id, this.medium.id])
      await this.$store.dispatch('Medium/getMedium', {
        data: this.medium.id,
        options: { populate: true }
      })
      await this.$store.dispatch('Medium/setMediaTags')
      this.savingNetworkTag = false
    }
  },
  computed: {
    mediumTags () {
      if (!this.mediumComputed.MediumTags) return []
      return JSON.parse(JSON.stringify(this.mediumComputed.MediumTags)).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    mediumComputed () {
      return this.$store.state.Medium.media_list.find(medium => medium.id === this.mediumId)
    },
    unusedNetworktagsInMedium () {
      if (!this.$store.state.Medium.media_tags) return []
      const matchingTags = this.$store.state.Medium.media_tags.filter((mt) => {
        return !mt.media.includes(this.mediumId)
      })
      return matchingTags.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    unusedNetworktagsInNetwork () {
      const mediaTagsUnused = JSON.parse(JSON.stringify(this.$store.state.Medium.media_tags_unused))
      return mediaTagsUnused.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },

    copiedMediaTagsExistsInStore () {
      return this.$store.state.Clipboard.copied_media_tags.length !== 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.saving-tag {
  opacity: 0;
  &.visible {
    opacity: 1;
  }
}
.items-container {
  display: flex;
  flex-direction: column;
  .mediumTagsUsed, .unusedTags {
    display: inline-flex;
    border: 0px solid red;
    flex-wrap: wrap;
    justify-content: flex-start;
    .no-tags-warning {
      margin-right: 20px;
      color: $--color-text-secondary;
    }
  }
  .mediumTags {
    border-bottom: $--border-light;
    padding: 0px 0px 0px 0px;
    margin-bottom: 10px;
    &.tags-used {
      margin-top: 10px;
    }
    .tag, button {
      margin: 0px 10px 10px 0px;
      background-color: rgba($--color-primary, 0.6);
      border: 1px solid rgba(black, 0.8);
      border-radius: 5px;
    }
    .tag-unused {
      opacity: 0.5;
      color: #fff;
    }
    button {
      margin: 0px 10px 10px 0px;
    }
    .input-new-tag {
      width: 100px;
    }
  }
}
p.error {
  color: $--color-warning;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/MediumTagsEditor.vue